import { InfoIcon } from 'lucide-react'

import { VideoTutorials } from '@/entities/video-tutorial'

import { PageNavigatorRegister } from '@/shared/components/PageNavigator'
import { Button } from '@/shared/components/ui/button'
import { Layout } from '@/shared/components/ui/layout'
import {
	ResizableHandle,
	ResizablePanel,
	ResizablePanelGroup,
} from '@/shared/components/ui/resizable'
import { SidebarProvider } from '@/shared/components/ui/sidebar'
import { VideoTag } from '@/shared/generated'

import { GlobalSetsContent } from './GlobalPcSetsContent'
import { GlobalPcSetsHeader } from './GlobalPcSetsHeader'
import { GlobalPcSetsProvider } from './GlobalPcSetsProvider'
import { GlobalPcSetsSidebar } from './GlobalPcSetsSidebar'

export default function GlobalPcSetsPage() {
	return (
		<GlobalPcSetsProvider>
			<GlobalPcSetsHeader />
			<SidebarProvider className='min-h-0 flex-1 items-start'>
				<ResizablePanelGroup direction='horizontal' className='h-full'>
					<ResizablePanel
						defaultSize={20}
						minSize={15}
						maxSize={50}
						className='flex flex-col'
					>
						<GlobalPcSetsSidebar />
					</ResizablePanel>
					<ResizableHandle withHandle />
					<ResizablePanel defaultSize={80} minSize={60}>
						<Layout row className='h-full overflow-hidden'>
							<PageNavigatorRegister>
								<VideoTutorials tags={[VideoTag.WhatIf]}>
									<Button size='icon' className='ml-auto' variant='ghost'>
										<InfoIcon />
									</Button>
								</VideoTutorials>
							</PageNavigatorRegister>
							<GlobalSetsContent />
						</Layout>
					</ResizablePanel>
				</ResizablePanelGroup>
			</SidebarProvider>
		</GlobalPcSetsProvider>
	)
}
